const DESCRIPTION_PLACEHOLDER_REGEX = /^desc(ription)?$/i

function sanitiseNlsDescriptionLine(line?: string): string | undefined {
  const cleanedLine = line?.replace(/\*\*/g, '').replace(/\s+/g, ' ').trim()

  if (!cleanedLine || DESCRIPTION_PLACEHOLDER_REGEX.test(cleanedLine)) {
    return undefined
  }

  return cleanedLine
}

export function getFirstMeaningfulNlsDescriptionLine(lines?: Array<string>): string | undefined {
  return lines?.map(sanitiseNlsDescriptionLine).find(Boolean)
}

export function hasMeaningfulNlsDescription(lines?: Array<string>): boolean {
  return !!getFirstMeaningfulNlsDescriptionLine(lines)
}
